import { Button, Tag, Tooltip } from "antd";
import { AuditoriaContaFinanceiraModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraModel";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { ColumnsType } from "antd/lib/table";
import { FileTextOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { listarHistoricoAuditoriaContaFinanceira } from "../../../../services/auditoriaContaFinanceiraService";
import dayjs from "dayjs";
import TableComponent from "../../../../components/table/tableComponent";

dayjs.locale("pt-br");

const HistoricoAuditoriaModal = () => {
  //estados globais
  const auditoriaContaFinanceiraState = useAppSelector((state) => state.auditoriaContaFinanceira);

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listarHistoricoAuditoriaContaFinanceira(auditoriaContaFinanceiraState.entity.id));
  }, [auditoriaContaFinanceiraState.entity]);

  const columns: ColumnsType<AuditoriaContaFinanceiraModel> = [
    {
      title: "STATUS",
      dataIndex: "denominacaoStatusAuditoria",
      render: (_, record) => <Tag key={record.denominacaoStatusAuditoria}>{record.denominacaoStatusAuditoria}</Tag>,
    },
    {
      title: "OBSERVAÇÃO",
      dataIndex: "observacao",
      align: "center",
      render: (_, record) =>
        record.observacao && (
          <>
            <Tooltip placement="top" title={record.observacao}>
              <Button>
                <FileTextOutlined />
              </Button>
            </Tooltip>
          </>
        ),
    },
    {
      title: "USUÁRIO",
      dataIndex: "usuario",
    },
    {
      title: "DATA",
      dataIndex: "dataHora",
      render: (_, record) => <>{record.dataHora && dayjs(record.dataHora).format("DD/MM/YYYY HH:mm")}</>,
    },
  ];

  return <TableComponent data={auditoriaContaFinanceiraState.listHistorico} columns={columns} loading={auditoriaContaFinanceiraState.loadingHistorico} />;
};

export default HistoricoAuditoriaModal;
